import React from "react";
import moment from 'moment';
import api from "../../../utils/api";
import {API_ROOT} from "../../../constants";
import {PLANS, PLANS_ID} from "../../../constants/plans";
import {Button} from "react-bootstrap";

export const fetchBillingLink = () => {
  api.post(`${API_ROOT}/pro/manage-billing`)
    .then((res) => {
      const url = res.data.session.url;
      if (url) {
        window.open(url, '_blank');
      }
    })
    .catch(e => {
      console.error(e)
      alert('Sorry, an error has occurred')
    });
};

const Details = ({
  cardType,
  productId,
  lastFour,
  status,
  amount,
  interval,
  nextBilling,
  email,
  currency = '$',
  stripeCustomer,
  updateUrl,
  onCancel,
  onUpgrade
}) => {
  const planLabel = PLANS_ID[productId]?.label;

  return <>
    <h4 className="color-purple mb-3">Account</h4>
    <table className="account-table mb-3 w-100 ms-auto me-auto grey">
      <tr className="pb-4">
        <td>Email</td>
        <td className="text-end font-weight-bold">{email}</td>
      </tr>
      <tr>
        <td>Status</td>
        <td className="text-end font-weight-bold">{status || 'Incomplete'}</td>
      </tr>
      <tr>
        <td>Current plan</td>
        <td className="text-end font-weight-bold">
          {planLabel ? `${planLabel} - ` : ''} {currency.toUpperCase()} {amount/100 || '-'} / {interval || '-'}
        </td>
      </tr>
      {nextBilling && <tr>
        <td>Next billing date</td>
        <td className="text-end font-weight-bold">
          {moment.unix(nextBilling).format('DD MMM YY')}
        </td>
      </tr>}
      <tr>
        <td>Payment method</td>
        <td className="text-end font-weight-bold">
          {cardType && `${cardType.toUpperCase()}`} {lastFour && `•••• ${lastFour}`}
        </td>
      </tr>
    </table>
    {productId === PLANS.PRO.id && <div className="text-end">
      <Button
        size="sm"
        variant="outline-primary"
        onClick={() => onUpgrade(false)}
      >
        Upgrade →
      </Button>
    </div>}
    {stripeCustomer && <div
      className="link color-purple text-decoration-none"
      onClick={fetchBillingLink}>
      Manage billing →
    </div>}
    {!stripeCustomer && <div>
      <a
        className="link color-purple text-decoration-none"
        href={updateUrl}
        target="_blank"
      >
        Update details →
      </a>
    </div>}
    <div>
      <a
        className="link color-purple text-decoration-none"
        onClick={onCancel}
      >
        Cancel →
      </a>
    </div>
  </>
};

export default Details;
